// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"19":"511ba32f","473":"cb8b49a5","625":"ab36a1bd","863":"bb35c1f8","868":"5bfe2352","961":"6758061d","980":"601861b4"}[chunkId] + ".chunk.css";
};